import AxiosInstance from "../services/networkServices";

export const uploadImage = async (payload) => {
    const res = await AxiosInstance.post(`/upload`, payload);
    return res.data;
}

/** Media record from POST /upload (handles uploadImage return shape and raw axios response). */
export const getUploadedMediaRecord = (response) => {
    if (!response) return null;
    if (response._id) return response;
    if (response.data?._id) return response.data;
    if (response.data?.data?._id) return response.data.data;
    return null;
};

export const deleteImage = async (payload) => {
    const res = await AxiosInstance.post(`/user/uploads/delete`, payload);
    return res.data;
}
